<template>
  <div class="note-item" @click="toCookBook">
    <div class="item-img">
      <img v-lazy="currentItem.r.img" alt="" />
    </div>
    <div class="item-name">
      {{ currentItem.r.n }}
    </div>
    <div class="item-story">
      {{ currentItem.r.cookstory }}
    </div>
    <div class="item-user">
      <img v-lazy="currentItem.r.a.p" alt="" class="user-img" />
      <span>{{ currentItem.r.a.n }}</span>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Lazyload, List } from "vant";

Vue.use(Lazyload, List);

export default {
  //props methods data computed watch
  data() {
    return {
      currentObj: this.currentItem,
      currentid: this.currentItem.r.id,
    };
  },
  props: {
    currentItem: {
      type: Object,
    },
  },
  methods: {
    toCookBook() {
      this.$router.push({
        name: "cookbook",
        params: {
          foodid: this.currentid,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.note-item {
  margin: 0px 3px;
  color: #333;
  padding: 0px 3px;
  margin-bottom: 10px;
  background: rgba(147, 207, 240, 0.2);
  border-radius: 30px;
  overflow: hidden;
  font-size: 14px;
  .item-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 5px;
    line-height: 20px;
    margin: 3px 0px;
  }
  .item-story {
    padding: 0px 5px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 12px;
  }
  .item-user {
    font-size: 10px;
    padding: 5px;
    color: #999;
  }
  .user-img {
    vertical-align: middle;
    margin: 0px 5px 0px 0px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: inline-block;
  }
}
</style>